module.exports = __webpack_public_path__ + "static/media/pathFirst.9482b75a.svg";